/*
  Vidéos « au défilement » : une vidéo marquée data-scroll-play démarre quand le visiteur arrive
  à sa hauteur sur la page, se met en pause et revient au début quand il s'en éloigne.
  Sans le son (obligatoire pour une lecture automatique), en boucle.
*/
(function () {
  'use strict';
  if (window.cocoonScrollVideo) return;
  window.cocoonScrollVideo = true;

  var warm = null;
  var play = null;

  function list(root) {
    return Array.prototype.slice
      .call((root || document).querySelectorAll('video[data-scroll-play]'))
      .filter(function (v) { return !v.hasAttribute('data-sp-ready'); });
  }

  function init(root) {
    var vids = list(root);
    if (!vids.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      // Pas de lecture automatique : le visiteur lance lui-même la vidéo.
      vids.forEach(function (v) {
        v.setAttribute('data-sp-ready', '');
        v.preload = 'metadata';
        v.controls = true;
      });
      return;
    }

    if (!warm) {
      // Charge la vidéo un peu avant qu'elle n'apparaisse, pour un démarrage immédiat.
      warm = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.preload = 'auto';
          warm.unobserve(en.target);
        });
      }, { rootMargin: '700px 0px' });

      play = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            var p = v.play();
            if (p && p.catch) {
              p.catch(function (err) {
                // Lecture refusée (ex. économie d'énergie sur iPhone) : on laisse le bouton lecture.
                if (err && err.name === 'NotAllowedError') v.controls = true;
              });
            }
          } else {
            v.pause();
            if (v.currentTime > 0.05) {
              try { v.currentTime = 0; } catch (err) { /* vidéo pas encore chargée */ }
            }
          }
        });
      }, { threshold: 0.4 });
    }

    vids.forEach(function (v) {
      v.setAttribute('data-sp-ready', '');
      v.muted = true;
      warm.observe(v);
      play.observe(v);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Éditeur de thème : réactive les vidéos quand une section est rechargée.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();